var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"viewport-gutter"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-4y-gray-900 pt-16 pb-16 max-w-183"},[_vm._v("\n      "+_vm._s(_vm.tr('pages.sales.buy.sellerNote.text'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }